import { css } from '@emotion/core'
import { breakpoints } from '~/utils/styles'

export const base = css`
	padding: 0 20px;
	@media (min-width: ${breakpoints.tablet}px) {
		margin: 0 auto;
		padding: 0 40px;
	}
`